import React from 'react';
import OrderStatus from "../components/OrderStatus";

export function OrderStatusColumnFormatter(cellContent) {
  return <OrderStatus variant={'badge'} size={'lg'} statusID={cellContent} customClassNames={'w-100px'}/>
}
